import styled from "styled-components/native";
import Title from "../Text";
import { font, text } from "../theme";

export const MediumTitle = styled(Title)`
  font-family: ${font.defaultSemiBold};
  font-size: ${text.larger.size};
`;
